import React from 'react';
import { Link } from "react-router-dom";
import StatusBadge from "../../../js/buttonstatus.jsx";

const normalizeBuyerUsername = (value) => String(value || '').replace(/<[^>]*>/g, '').trim();

export const AccountsOrdersHeader = ({ getIcon, onSort }) => (
    <>
        <th className="py-2 px-1" style={{ width: '20%' }}>
            Tên sản phẩm
        </th>
        <th className="py-2 px-1" style={{ width: '25%' }}>
            id / Người mua
        </th>
        <th
            className="py-2 px-1 text-left cursor-pointer select-none"
            style={{ width: '10%' }}
            onClick={() => onSort('price')}
        >
            Coins nhận{getIcon('price')}
        </th>
        <th
            className="py-2 px-1 cursor-pointer select-none"
            style={{ width: '8%' }}
            onClick={() => onSort('amount')}
        >
            Số lượng{getIcon('amount')}
        </th>
        <th
            className="py-2 px-1 cursor-pointer select-none"
            style={{ width: '14%' }}
        >
            Trạng thái {getIcon('status')}
        </th>
        <th
            className="py-2 px-1 cursor-pointer select-none"
            style={{ width: '40%' }}
        >
            Accounts bán và note
        </th>
    </>
);

export const AccountsOrdersRow = ({ item_account, nutxuly, account_edits, switch_router, category_main, activeBuyerId, onShowBuyer }) => {
    const rowId = item_account.id;
    const isActive = activeBuyerId === rowId;

    return (
        <>
        <td className="py-3 px-2 font-medium capitalize">
            <Link className="flex items-center justify-between flex-1 text-black no-underline"
                to={`/shop/accounts/product/play/${item_account.accounts_alias}_${item_account.id}`}
            >
                {item_account.accounts_caption}
                <div className="text-xl">
                    {'\u27A4'}
                </div>
            </Link>
        </td>
        <td className="py-2 px-1">
            <div className="font-medium capitalize">{item_account.id}</div>
            <div className="mt-1">
                <div dangerouslySetInnerHTML={{ __html: item_account.buyer_username }} />
                <div className="float-right">
                    <button
                        disabled={nutxuly === 1}
                        onClick={() => {
                            const buyerUsername = normalizeBuyerUsername(item_account.buyer_username);
                            if (buyerUsername && onShowBuyer) {
                                onShowBuyer(rowId, buyerUsername);
                                return;
                            }
                            if (item_account.accounts_type === "local") {
                                account_edits(item_account, category_main);
                            } else {
                                switch_router('/shop/accounts/sellers/api/settings');
                            }
                        }}
                        className="text-xs inline-flex font-medium rounded-full px-2 py-1 bg-white text-black"
                    >
                        {nutxuly === 1 && (
                            <div className="spinner-border spinner-border-sm" role="status" />
                        )}
                        <div>
                            {isActive ? "thông tin x" : "thông tin"}
                        </div>
                    </button>
                </div>
            </div>
        </td>
        <td className="py-2 px-1">{item_account.accounts_orders_coins}</td>
        <td className="py-2 px-1">{item_account.orders_amount}</td>
        <td className="py-2 px-1">
            <div className="mb-1"><StatusBadge status={item_account.accounts_orders_status} /></div>
            <div>
                {item_account.accounts_type === "local"
                    ? "Trong kho"
                    : item_account.accounts_type === "api"
                        ? "Qua API"
                        : item_account.accounts_type}
            </div>
        </td>
        <td className="py-2 px-1">
            {item_account.accounts_orders_note ? (
                <div className="mb-1 inline-block rounded bg-white px-1 py-0 leading-tight text-purple-600">
                    note: {item_account.accounts_orders_note}
                </div>
            ) : null}
            <div className="text-xs">{item_account.orders_url}</div>
        </td>
        </>
    );
};
